import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../features/admin/need_advice/slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const need_advice = useSelector((state) => state?.need_advice?.need_advice);

  console.log(need_advice, "need_advice");

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = need_advice?.current_page) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: need_advice?.per_page,
      }),
    );
  };

  return {
    need_advice,
    name,
    setName,
    fetch,
  };
};
